import type { ContentfulArticleSearchResponse } from 'autogen/swagger/all';
import type { SelectType } from '../shared/types';

export function getSelectTypeIds(selectType: SelectType, model?: ContentfulArticleSearchResponse): string[] {
    if (!model) return [];

    switch (selectType) {
        case 'section':
            return model.selectedSectionIds;
        case 'topic':
            return model.selectedTopicIds;
        default:
            console.error(`SelectType "${selectType}" is not recognized`);
            return [];
    }
}

export default function isSelected(
    entryId: string,
    selectType: SelectType,
    model?: ContentfulArticleSearchResponse
): boolean {
    const sectionsIds = getSelectTypeIds(selectType, model);
    if (!sectionsIds) return false;

    return sectionsIds.includes(entryId);
}
